/**
 * Automatic Palette upgrade (2026-09-20, explicit user instruction):
 * when the cart holds at least one full pallet's worth of a product's base
 * unit (e.g. 33 Kartons of a product with 33 Kartons per Palette), those
 * Kartons are converted to Palette line(s); the remainder stays as Kartons.
 *
 * Safety: only converts when the Palette variant really has a Palette price
 * (= VE x base price). Products whose Palette price isn't set yet (still equal
 * to the base price / 0) are never touched.
 *
 * Runs on load, after every /cart/add, /cart/change and /cart/update, and
 * before checkout. PALLET_VE = base units (Kartons) per Palette, keyed by the
 * first 7 chars of the base variant's SKU - same numbers as
 * snippets/hygeon-pallet-ve.liquid (keep both in sync).
 */
(function () {
  'use strict';
  var PALLET_VE = {
    'PAP-007': 33, 'PAP-017': 33, 'PAP-008': 40, 'PAP-009': 40,
    'PAP-010': 28, 'PAP-014': 28, 'PAP-016': 28, 'PAP-015': 12, 'PAP-019': 12,
    'PAP-020': 21, 'PAP-018': 14, 'PAP-021': 36, 'PAP-022': 36, 'PAP-023': 44,
    'PAP-024': 42, 'PAP-025': 20, 'PAP-026': 20, 'PAP-027': 48, 'PAP-036': 24,
    'MUE-007': 72, 'MUE-010': 30, 'MUE-012': 66, 'MUE-008': 80, 'SCH-001': 80, 'SCH-002': 80,
    'SCH-003': 80, 'SCH-004': 80, 'MUE-009': 60, 'MUE-011': 60, 'TEX-001': 45,
    'SCH-005': 48, 'SPE-006': 48, 'REI-005': 50, 'PAP-035': 56, 'PAP-034': 60,
    'REI-002': 60, 'REI-003': 60, 'REI-004': 60, 'REI-006': 60, 'REI-007': 60,
    'REI-008': 60, 'REI-009': 60, 'REI-010': 60, 'SCH-007': 60, 'SCH-008': 60,
    'SPE-008': 64, 'SPE-009': 64, 'SPE-001': 72, 'SPE-002': 78, 'SPE-004': 78,
    'SPE-007': 90, 'SPE-010': 90, 'PAP-033': 96, 'SPE-005': 96, 'SPE-013': 96,
    'SPE-014': 96, 'SCH-006': 96, 'SPE-012': 120, 'SPE-003': 192, 'SPE-011': 220
  };
  window.HygeonPalletVE = PALLET_VE;
  var busy = false;
  var cache = {};

  function sku7(s) { return String(s || '').slice(0, 7); }
  function isPaletteTitle(t) { return /(^|\s\/\s)Palette$/.test(String(t || '').trim()); }

  function product(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    }
    return cache[handle];
  }

  function refreshUi() {
    ['cart:refresh', 'shopify:cart:lines-update', 'cart:updated'].forEach(function (n) {
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
    });
    if (/^\/cart\/?$/.test(location.pathname)) location.reload();
  }

  function normalize() {
    if (busy) return Promise.resolve(false);
    busy = true;
    // 2026-10-03: shared, deduped cart read — see
    // assets/hygeon-shared-cart-fetch.js's own header comment for why.
    return window.HygeonCartFetch()
      .then(function (cart) {
        var jobs = [];
        (cart.items || []).forEach(function (it) {
          var n = PALLET_VE[sku7(it.sku)];
          if (!n || it.quantity < n || isPaletteTitle(it.variant_title)) return;
          jobs.push(product(it.handle).then(function (p) {
            var base = p.variants.filter(function (v) { return v.id === it.variant_id; })[0];
            if (!base) return null;
            var bo = base.options.slice(0, -1).join('|');
            var pal = p.variants.filter(function (v) {
              return v.options[v.options.length - 1] === 'Palette' && v.options.slice(0, -1).join('|') === bo;
            })[0];
            if (!pal || pal.price !== base.price * n) return null; // Palette price not set (yet): leave alone
            return { it: it, pal: pal, n: n };
          }));
        });
        return Promise.all(jobs);
      })
      .then(function (res) {
        var todo = (res || []).filter(Boolean);
        if (!todo.length) { busy = false; return false; }
        var chain = Promise.resolve();
        todo.forEach(function (j) {
          var pallets = Math.floor(j.it.quantity / j.n);
          var rest = j.it.quantity - pallets * j.n;
          chain = chain
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: j.pal.id, quantity: pallets })
              });
            })
            .then(function () {
              var upd = {};
              upd[j.it.key] = rest;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ updates: upd })
              });
            });
        });
        return chain.then(function () { busy = false; refreshUi(); return true; });
      })
      .catch(function () { busy = false; return false; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalize);
  else normalize();
  window.addEventListener('pageshow', function (e) { if (e.persisted) normalize(); });

  if (window.fetch && !window.fetch.__hygeonPalletWrapped) {
    var orig = window.fetch;
    var wrapped = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/(add|change|update)(\.js)?(\?|$|#)/.test(url) && !busy) {
        p.then(function () { setTimeout(normalize, 80); }).catch(function () {});
      }
      return p;
    };
    wrapped.__hygeonPalletWrapped = true;
    window.fetch = wrapped;
  }

  document.addEventListener('click', function (e) {
    var trg = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!trg) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    normalize().then(function () { location.href = '/checkout'; });
  }, true);

  /* ---- Product page: typing a full pallet's worth switches the page to Palette ---- */
  (function pagePart() {
    if (!/^\/products\//.test(location.pathname)) return;
    var handle = location.pathname.split('/')[2];
    var prod = null;
    var pending = null; // { id, qty } Karton remainder to add together with the pallets
    var origin = null;  // { id, qty } what the customer typed before the automatic switch
    var working = false;

    function qtyInput() { return document.querySelector('quantity-selector-component input[name="quantity"]'); }
    function veRadios() {
      return Array.prototype.slice.call(document.querySelectorAll('variant-picker input[type=radio]'))
        .filter(function (r) { return r.value === 'Palette' || /^(Karton|Kanister|Stück|Rolle)$/.test(r.value); });
    }

    /**
     * Real bug found live (2026-09-22, reported by the client with a screenshot):
     * typing "67" into the Karton quantity field and clicking "In den Warenkorb
     * legen"/"Jetzt zum Checkout" (Shopify's own accelerated-checkout button,
     * rendered as an unreachable cross-origin iframe our own click listener below
     * can never intercept) too quickly added 67 PALETTEN to the cart instead of
     * the correct 2 Paletten + 1 Karton. Root cause: the variant radio switches
     * to Palette almost immediately on radio.click(), but the corrected quantity
     * value isn't written until after `waitFor(...)` + a 400ms settle delay —
     * a real race window where the NEW variant id and the OLD (un-corrected)
     * quantity can both be in the DOM at once when a fast real click submits
     * the form. buttonsBusy() disables every real submission path (both real
     * add-to-cart buttons, by disabling them directly, and the accelerated-
     * checkout container, via pointer-events, since its actual button lives
     * inside a cross-origin iframe this script cannot disable directly) for the
     * whole duration of a pending conversion, closing that window instead of
     * trying to guess/undo a wrong quantity after the fact.
     */
    function buyTriggers() {
      return Array.prototype.slice.call(document.querySelectorAll(
        '[ref="addToCartButton"], button[name="add"], [ref="acceleratedCheckoutButtonContainer"]'
      ));
    }
    function setBusy(isBusy) {
      buyTriggers().forEach(function (el) {
        if (el.tagName === 'BUTTON') {
          el.disabled = isBusy;
        } else {
          el.style.pointerEvents = isBusy ? 'none' : '';
          el.style.opacity = isBusy ? '0.5' : '';
        }
      });
    }
    function note(text) {
      var n = document.querySelector('.hygeon-pallet-note');
      if (!text) { if (n) n.remove(); return; }
      if (!n) {
        n = document.createElement('p');
        n.className = 'hygeon-pallet-note';
        n.style.cssText = 'margin:8px 0 0;font-size:13px;color:#1565C0;';
        var q = document.querySelector('quantity-selector-component');
        if (q && q.parentNode) q.parentNode.insertBefore(n, q.nextSibling);
      }
      n.textContent = text;
      if (origin) {
        var a = document.createElement('a');
        a.href = '#';
        a.textContent = ' Zurück zu ' + origin.unit;
        a.style.cssText = 'margin-left:6px;text-decoration:underline;';
        a.addEventListener('click', function (ev) { ev.preventDefault(); goBack(); });
        n.appendChild(a);
      }
    }
    function goBack() {
      if (!origin || working) return;
      var o = origin;
      working = true;
      setBusy(true);
      pending = null;
      origin = null;
      note('');
      var radio = veRadios().filter(function (r) { return r.value === o.unit; })[0];
      if (!radio) { working = false; setBusy(false); return; }
      radio.click();
      waitFor(function () { return selectedId() === o.id; }, 4000).then(function () {
        return new Promise(function (r) { setTimeout(r, 400); });
      }).then(function () {
        var i2 = qtyInput();
        if (i2) {
          i2.value = String(o.qty);
          i2.dispatchEvent(new Event('input', { bubbles: true }));
          i2.dispatchEvent(new Event('change', { bubbles: true }));
        }
        working = false;
        setBusy(false);
      });
    }
    function getProduct() {
      if (prod) return Promise.resolve(prod);
      return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { prod = p; return p; });
    }
    function selectedId() {
      var f = document.querySelector('product-form-component form, form[action*="/cart/add"]');
      var i = f && f.querySelector('[name="id"]');
      return i ? parseInt(i.value, 10) : null;
    }
    function waitFor(fn, ms) {
      return new Promise(function (res) {
        var t0 = Date.now();
        (function tick() {
          var v = fn();
          if (v || Date.now() - t0 > ms) return res(v);
          setTimeout(tick, 100);
        })();
      });
    }

    function onQty() {
      if (working) return;
      var inp = qtyInput();
      if (!inp) return;
      var q = parseInt(inp.value, 10) || 0;
      // Disable every real submission path for the duration of the async
      // lookup+conversion below, even before we know whether a conversion
      // is actually needed — closes the race window on the very first
      // fetch too, not just the radio-switch/quantity-correction part
      // further down (see the long comment on buyTriggers()/setBusy()).
      setBusy(true);
      getProduct().then(function (p) {
        var cur = p.variants.filter(function (v) { return v.id === selectedId(); })[0];
        if (!cur) { setBusy(false); return; }
        var isPal = cur.options[cur.options.length - 1] === 'Palette';
        if (isPal) { pending = null; setBusy(false); return; }
        var n = PALLET_VE[sku7(cur.sku)];
        if (!n || q < n) { pending = null; note(''); setBusy(false); return; }
        var bo = cur.options.slice(0, -1).join('|');
        var pal = p.variants.filter(function (v) {
          return v.options[v.options.length - 1] === 'Palette' && v.options.slice(0, -1).join('|') === bo;
        })[0];
        if (!pal || pal.price !== cur.price * n) { setBusy(false); return; } // no real Palette price: leave alone
        var pallets = Math.floor(q / n), rest = q - pallets * n;
        working = true;
        setBusy(true);
        var radio = veRadios().filter(function (r) { return r.value === 'Palette'; })[0];
        if (!radio) { working = false; setBusy(false); return; }
        radio.click();
        waitFor(function () { return selectedId() === pal.id; }, 4000).then(function () {
          return new Promise(function (r) { setTimeout(r, 400); });
        }).then(function () {
          var i2 = qtyInput();
          if (i2) {
            i2.value = String(pallets);
            i2.dispatchEvent(new Event('input', { bubbles: true }));
            i2.dispatchEvent(new Event('change', { bubbles: true }));
          }
          pending = rest > 0 ? { id: cur.id, qty: rest } : null;
          origin = { id: cur.id, qty: q, unit: cur.options[cur.options.length - 1] };
          note(q + ' ' + (cur.options[cur.options.length - 1] === 'Karton' ? 'Kartons' : cur.options[cur.options.length - 1]) +
               ' = ' + pallets + (pallets === 1 ? ' Palette' : ' Paletten') +
               (rest > 0 ? ' + ' + rest + ' ' + (cur.options[cur.options.length - 1] === 'Karton' ? 'Karton' + (rest === 1 ? '' : 's') : cur.options[cur.options.length - 1]) + ' (wird automatisch mit hinzugefügt)' : ''));
          working = false;
          setBusy(false);
        });
      });
    }

    document.addEventListener('change', function (e) {
      if (working) return;
      if (e.target && e.target.matches && e.target.matches('variant-picker input[type=radio]')) {
        // customer changed the selection himself: drop the automatic state
        pending = null;
        origin = null;
        note('');
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('quantity-selector-component input[name="quantity"]')) onQty();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('quantity-selector-component input[name="quantity"]')) setTimeout(onQty, 50);
    });

    // add the Karton remainder together with the pallets
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[ref="addToCartButton"], button[name="add"]');
      if (!b || !pending || b.__hygeonPalletGo) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var job = pending;
      pending = null;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: job.id, quantity: job.qty })
      }).then(function () {
        b.__hygeonPalletGo = true;
        b.click();
        setTimeout(function () { b.__hygeonPalletGo = false; note(''); }, 500);
      });
    }, true);
  })();
})();
